<script setup lang="ts">
import type { Component } from 'vue'
import { useRoute } from 'vue-router'

interface NavItem { label: string; icon: Component; to: string; matchNames: string[] }
defineProps<{ items: NavItem[]; logoSrc: string }>()
const route = useRoute()
</script>

<template>
  <aside class="ck-sidebar">
    <div class="brand">
      <img :src="logoSrc" alt="CK">
      <div><strong>CK</strong><span class="ck-serif-italic">Car Repair Service</span></div>
    </div>
    <nav class="nav" aria-label="Navegação principal">
      <div class="section-label">Operacional</div>
      <router-link
        v-for="item in items"
        :key="item.label"
        :to="item.to"
        class="nav-item"
        :class="{ active: item.matchNames.includes(String(route.name)) }"
      >
        <component :is="item.icon" :size="19" />
        <span>{{ item.label }}</span>
      </router-link>
    </nav>
    <div class="footer"><slot name="footer" /></div>
  </aside>
</template>

<style scoped>
.ck-sidebar { display: flex; flex-direction: column; width: 248px; flex-shrink: 0; height: 100vh; position: sticky; top: 0; border-right: 1px solid var(--color-border); background: var(--color-bg); }
.brand { display: flex; align-items: center; gap: 12px; padding: 22px 22px 18px; border-bottom: 1px solid var(--color-border); }
.brand img { height: 40px; }
.brand strong { display: block; font-family: var(--font-display); font-weight: 800; font-size: 18px; color: var(--color-text); line-height: 1; }
.brand span { display: block; font-size: 12px; margin-top: 2px; }
.nav { flex: 1; padding: 14px 12px; overflow-y: auto; }
.section-label { padding: 6px 12px 8px; font-size: 10.5px; font-weight: 700; letter-spacing: var(--ls-widest); color: var(--color-text-faint); }
.nav-item { display: flex; align-items: center; gap: 12px; width: 100%; padding: 11px 13px; margin-bottom: 3px; border-radius: 11px; color: var(--color-text-muted); font-weight: 500; font-size: 14.5px; text-decoration: none; }
.nav-item:hover { background: var(--color-surface-muted); }
.nav-item.active { background: rgba(237, 107, 26, .14); color: var(--ck-orange-500); font-weight: 700; }
.footer { padding: 14px; border-top: 1px solid var(--color-border); }
</style>
